(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  /* CUSTOM (Betsy & Sons) 2026-07-28: Laufband/Marquee.
     Klont den Eintrags-Satz, bis das Band breiter ist als der sichtbare Bereich (+ 1 Satz),
     und verschiebt exakt um die Startposition des 2. Satzes -> nahtlose, gleichmaessige Schleife.
     Geschwindigkeit = px/s (unabhaengig von der Inhaltsbreite). */
  class AnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.announcement-bar__marquee-track');
      if (!this.track) return;
      // Getrennte Geschwindigkeit fuer Desktop/Mobil (px/s); Mobil-Fallback = Desktop.
      this.speedDesktop = parseFloat(this.dataset.speed) || 40;
      this.speedMobile = parseFloat(this.dataset.speedMobile) || this.speedDesktop;
      this.mobileQuery = window.matchMedia('(max-width: 639px)');
      this.setCount = this.track.children.length;
      this.originalHTML = this.track.innerHTML;
      this.build = this.build.bind(this);
      this.build();
      this.onResize = this.debounce(this.build, 200);
      window.addEventListener('resize', this.onResize);
      if (this.dataset.pauseOnHover === 'true') {
        this.addEventListener('mouseenter', () => this.classList.add('is-paused'));
        this.addEventListener('mouseleave', () => this.classList.remove('is-paused'));
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }

    build() {
      if (this.setCount === 0) return;
      // Geschwindigkeit je nach Viewport waehlen (build() laeuft auch bei resize neu).
      this.speed = this.mobileQuery.matches ? this.speedMobile : this.speedDesktop;
      // auf einen Satz zuruecksetzen und Animation kurz aussetzen
      this.track.style.animation = 'none';
      this.track.innerHTML = this.originalHTML;
      const setWidth = this.track.scrollWidth;
      if (setWidth === 0) return;
      const needed = this.offsetWidth + setWidth;
      let copies = 1;
      while (this.track.scrollWidth < needed && copies < 60) {
        this.track.insertAdjacentHTML('beforeend', this.originalHTML);
        copies++;
      }
      // Verschiebe-Distanz = Startposition des ersten Kindes des 2. Satzes (inkl. gap)
      const secondSetFirst = this.track.children[this.setCount];
      const distance = secondSetFirst ? secondSetFirst.offsetLeft : setWidth;
      this.track.style.setProperty('--ab-marquee-distance', distance + 'px');
      this.track.style.setProperty('--ab-marquee-duration', distance / this.speed + 's');
      void this.track.offsetWidth; // reflow erzwingen
      this.track.style.animation = '';
    }

    debounce(fn, wait) {
      let t;
      return (...a) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...a), wait);
      };
    }
  }

  customElements.define('announcement-marquee', AnnouncementMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-carousel"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementCarousel extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-carousel__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-carousel__close')) {
        this.querySelector('.announcement-carousel__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-carousel', AnnouncementCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
